module.exports = __webpack_public_path__ + "static/2mynz-logo-white-de8abf9e82d206f2c6c3d35982366dd1.png";